
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ReportCard from './ReportCard.vue';
import AnalystReport from './AnalystReport.vue';
import IndustryReport from './IndustryReport.vue';
import CommonDropMenu from '@/components/common/CommonDropMenu.vue';
import CommonEmpty from '@/components/common/CommonEmpty.vue';
import { throttle } from '@/utils/tools';
import { STAT, URLVER, THROTTLE_TIME } from '@/config/config';
@Component({
  components: {
    ReportCard,
    AnalystReport,
    IndustryReport,
    CommonDropMenu,
    CommonEmpty,
  },
})
export default class OuterResearch extends Vue {
  @Prop() private reportList!: Array<object>;
  @Prop() private avatarList!: Array<object>;
  @Prop() private swiperIndex!: number;
  @Prop() private activeTabIndex!: number;
  @Prop() private slide!: number;
  @Prop() private mechanismList!: Array<object>;
  @Prop() private industryList!: Array<object>;
  @Prop() private listIsLoading!: boolean;
  @Prop() private listFinished!: boolean;
  @Prop() private popupShow!: boolean;
  @Prop() private name!: string;
  //底栏是否展示深度分析四个字
  deepReport = false;
  defaultValue = '最新';
  scrollTop = 0;
  ifShow = false;
  deep = null;
  chart = true;
  period = null;
  toDown = false;
  //控制行业研报header是否展示图表
  chart2 = false;
  //空状态样式
  emptyStyle = {
    paddingTop: '3.5rem',
    fontFamily: 'PingFangSC-Regular',
    fontSize: '0.32rem',
    color: 'rgba(0, 0, 0, 0.84)',
    letterSpacing: 0,
    textAlign: 'center',
    lineHeight: '0.4rem',
    fontWeight: 400,
  };
  options = [
    { label: '最新', value: 0 },
    { label: '近24h最热', value: 1 },
    { label: '近1周最热', value: 2 },
    { label: '近1⽉最热', value: 3 },
    { label: '近3⽉最热', value: 4 },
  ];
  @Watch('scrollTop')
  // eslint-disable-next-line consistent-return
  onChange(newVal: number, oldVal: number) {
    if (newVal > oldVal) {
      const screen = document.getElementsByClassName('screenFixed')[0] as any;
      screen.style.top = 0;
    } else {
      const screen = document.getElementsByClassName('screenFixed')[0] as any;
      screen.style.top = '1.8rem';
    }
  }
  handleListLoad() {
    this.$emit('handleListLoad');
  }
  chartChange() {
    this.$emit('chartChange');
  }
  chartChange1(val: boolean) {
    if (val) {
      window.hxmPageStat(`${STAT.follow}.ontb`, URLVER);
    } else {
      window.hxmPageStat(`${STAT.follow}.offtb`, URLVER);
    }
  }
  deepChange(val: boolean) {
    if (val) {
      this.deep = 1;
      this.deepReport = true;
      window.sessionStorage.setItem('deep', this.deep);
      window.hxmPageStat(`${STAT.follow}.onsd`, URLVER);
    } else {
      this.deep = null;
      this.deepReport = false;
      window.sessionStorage.setItem('deep', this.deep);
      window.hxmPageStat(`${STAT.follow}.offsd`, URLVER);
    }
    this.$emit('getDeep', this.deep);
  }
  scrollLoading() {
    this.scrollTop = document.documentElement.scrollTop;
    const screen = document.getElementsByClassName('screen')[0] as any;
    const screenFather = document.getElementsByClassName('screenFather')[0] as any;
    const sticky = document.getElementsByClassName('home-sticky-head')[0] as any;
    const fixedScreen = this.$refs.fixedScreen as any;
    const body = document.querySelector('body');
    if (screen && screenFather) {
      const { offsetTop, offsetHeight } = screen;
      const fatherOffset = screenFather.offsetTop;
      const stickyHight = sticky.offsetHeight;
      const add = offsetTop + offsetHeight + fatherOffset + stickyHight;
      if (document.documentElement.scrollTop >= add || document.body.scrollTop >= add) {
        if (this.ifShow) {
          return;
        } else {
          body.appendChild(fixedScreen);
          this.ifShow = true;
        }
      } else {
        this.ifShow = false;
      }
    }
  }
  mounted() {
    window.addEventListener(
      'scroll',
      throttle(() => this.scrollLoading(), THROTTLE_TIME),
      true
    );
  }
}
